import { namedParameters, singleParameter } from '/b2b/common/helpers/Redux/parameterize';

import { DOMAIN } from './Amplify.constants';
import { buildActionCreators } from '../../../common/helpers/Redux/buildActionCreators';
import { makeActionTypes } from '/b2b/common/helpers/Redux/makeActionTypes';

export const events = {
    /** @type {typeof singleParameter<typeof import('aws-amplify/auth').SignInOutput>} */
    nextStep: singleParameter,
    getUserDataSuccess: singleParameter,
    updateUserAttributesBegin: singleParameter,
    updateUserAttributesSuccess: namedParameters('params', 'response'),
    updateUserAttributesFailure: namedParameters('params', 'error'),
    verifyPhone: singleParameter,
};

export const types = makeActionTypes(
    /** @type {keyof typeof events} */ (Object.keys(events)),
    DOMAIN
);

export const actionCreators = buildActionCreators(events, types);

export default actionCreators;
